import { z } from 'zod';

export const ServiceOrderItemExecutionParamsSchema = z.object({
  orderId: z.uuid(),
  itemId: z.uuid(),
});

export type ServiceOrderItemExecutionParams = z.infer<typeof ServiceOrderItemExecutionParamsSchema>;

export const PlanServiceOrderItemResponseSchema = z.object({
  itemId: z.uuid(),
  executionStatus: z.string(),
  orderStatus: z.string(),
  waitingParts: z.boolean(),
});

export type PlanServiceOrderItemResponse = z.infer<typeof PlanServiceOrderItemResponseSchema>;

export const ApplyServiceOrderItemResponseSchema = z.object({
  itemId: z.uuid(),
  executionStatus: z.string(),
  orderStatus: z.string(),
  warnings: z.array(z.string()),
  stock: z
    .object({
      consumptionKind: z.enum(['IMMEDIATE', 'DEFERRED', 'SKIPPED']),
    })
    .nullable(),
});

export type ApplyServiceOrderItemResponse = z.infer<typeof ApplyServiceOrderItemResponseSchema>;
